import { render, staticRenderFns } from "./AreaEmbagadaGoias.vue?vue&type=template&id=4cef7961&lang=pug"
import script from "./AreaEmbagadaGoias.vue?vue&type=script&lang=js"
export * from "./AreaEmbagadaGoias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports